export const lightGrey = "#7E7474";
export const ivory = "#FCFFE7";
export const anEvenLighterShadeOfGrey = "#DFD3C3";
export const whitish = "#EEF1FF";